export const initialStateApp = {

    error: null,
    pageRef: '',
    gonogo: {},
    statusNetwork: true,
    loading: false
};

export const initialStateAuth = {

    user: {
        metadata: {
            accountId: '',
            branchId: '',
            terminalId: '',
            name: '',
            zone: ''
        },
        nickname: '',
        name: '',
        picture: '',
        email: '',
        userId: '',
        permissions: [],
        token: {
            id_token: '',
            expiresAt: 0
        },
        isAuthenticated: null
    },
    isLogin: false,
    email: ''    
};

// Page Qr-Scan
export const initialStateQr = {

    transaction: {
        transactionId: '',        
        benefitId: '',
        expiredIn: 0,
        subscriberUserData: {
            content: '',
            iv: ''
        }
    }
};

export const initialStateTransaction = {

    metadata: {
        transactionStatus: '',
        count: 0,
        files: []
    },
    
    entity: {

        transactionId: '',
        subscriberDni: '',
        subscriberCard: 0,
        benefitId: ''
    },

    // transación seleccionada
    activated: {
        transactionId: '',
        transactionNumber: 0,
        createdDate: 0,
        updatedDate: 0,
        expiredDate: 0,
        accountUserId: '',
        account: {
            id: '',
            branchId: '',
            terminalId: ''
        },
        benefit: {
            id: '',
            type: '',
            title: ''
        },
        subscriberUserId: 0,
        subscriber: {
            name: '',
            card: 0,
            dni: 0,
            program: {
                id: 0,
                description: ''
            }
        },
        amount: 0,
		discountAmount: 0,
        transactionStatus: 0
    },

    // listado de transacciones del historial
    list: {

        items: [],
        metadata: {
            page: 0,
            size: 0,
            nextKey: {
                createdDate: 0,
                transactionId: ''
            }
        }
    }
};

export const initialStateBenefit = {

    // beneficio seleccionado
    activated: {

        benefitId: '',
        accountId: {
            type: '',
            title: ''
        },
        fromDate: '',
        toDate: '',
        days: [],
        programs: [],
        branches: []
    },

    // listado de beneficios disponibles
    list: []
}